module.exports = __webpack_public_path__ + "static/media/notAllowed.18d763a6.svg";